import { render, staticRenderFns } from "./StudentCamera.vue?vue&type=template&id=0688e3b3&scoped=true"
import script from "./StudentCamera.vue?vue&type=script&lang=js"
export * from "./StudentCamera.vue?vue&type=script&lang=js"
import style0 from "./StudentCamera.vue?vue&type=style&index=0&id=0688e3b3&prod&lang=scss&scoped=true"
import style1 from "./StudentCamera.vue?vue&type=style&index=1&id=0688e3b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688e3b3",
  null
  
)

export default component.exports